import React from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import * as Styles from "../styles/PeriodContent.Modal.styles";
import alfredoIcon from "../assets/alfredo-icon.svg";
import PeriodContent from "./PeriodContent";

const PartialWithdrawalModal: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
}> = ({ isOpen, onRequestClose }) => {
  const {
    subsidiaryDataZustand,
  } = useCombinedStore((state) => {
    return {
      subsidiaryDataZustand: state.subsidiaryDataZustand,
    };
  });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onRequestClose()}
      style={Styles.customStyles}
      contentLabel="Main Modal"
      ariaHideApp={false}
    >
      <Styles.ModalWrapper
        tabIndex={-1}
      >
        <Styles.CloseButton onClick={() => onRequestClose()}>
          &times;
        </Styles.CloseButton>
        <Styles.ModalContent>
          <Styles.ModalHeader
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
            <Styles.ModalTitle>Período</Styles.ModalTitle>
            <Styles.ModalDescription>
              Confirme as Informações do Período.
            </Styles.ModalDescription>
          </Styles.ModalHeader>
          <Styles.ModalBody
            color={
              subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                .buttonsColor
            }
          >
            <PeriodContent />
          </Styles.ModalBody>
        </Styles.ModalContent>
      </Styles.ModalWrapper>
    </Modal >
  );
};

export default PartialWithdrawalModal;
